import Link from "next/link";
import React, { useState } from "react";
import News_item from "../../components/blog/news_item";
import Meta from "../../components/Meta";
import Image from "next/image";

import formatDate from "../../utils/dateFormatter";
import { getPaginatedPosts } from "../../lib/posts";


const Blog = ({ posts }) => {

  const [loadMoreBtn, setLoadMoreBtn] = useState(true);
  const [data, setdata] = useState(posts?.slice(0, 6) || []);

  const handleLoadMore = () => {
    setdata(posts);
    setLoadMoreBtn(false);
  };
  return (
    <>
      <Meta title="Blogs | Netzylo" />
      <div className='pt-[170px]  md:pt-[10rem] px-2'>

        <h6 className="text-jacarta-900 font-light font-display mt-[20px] mb-4 text-center text-[30px] md:text-[44px] dark:text-white  lg:text-[48px] leading-tight	">

        Explore the Future of Web3 Engagement        </h6>

        <p className="mb-[28px] max-w-[600px] mx-auto text-center text-[16px] md:text-[18px] font-normal ">
        From seamless onboarding to digital identities, stay informed on the latest in blockchain innovation.        </p>

      </div>
      {posts && <section className="relative  ">
        <div className="py-16 md:py-24 md:pt-12">
          <div className="container">
            {/* <!-- Featured Post --> */}
            <article className="mb-[1.875rem] md:mb-16">
              <div className="rounded-2xl flex flex-col overflow-hidden transition-shadow hover:shadow-lg md:flex-row">
                <figure className="group overflow-hidden md:w-1/2">
                  <Link href={`/blog/${data[0].slug}`}>
                    <Image
                      width={585}
                      height={455}
                      src={data[0]?.featuredImage?.sourceUrl}
                      alt={data[0]?.title}
                      className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105"
                    />
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div className="dark:border-jacarta-600 dark:bg-jacarta-900 border-jacarta-100 rounded-b-[1.25rem] border bg-white p-[10%] md:w-1/2 md:rounded-none md:rounded-r-[1.25rem]">
                  {/* <!-- Meta --> */}


                  <h2 className="font-display text-jacarta-900 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white sm:text-3xl">
                    <Link href={`/blog/${data[0].slug}`}>
                      {data[0].title}
                    </Link>
                  </h2>
                  <p className="dark:text-jacarta-200 mb-8">
                    <div className="line-clamp-3" dangerouslySetInnerHTML={{ __html: data[0].excerpt }} />
                  </p>

                  {/* <!-- Date / Time --> */}
                  <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                    <span>
                      <time>{formatDate(data[0].date)}</time>
                    </span>
                    {/* <span>•</span>
                    <span>3 min read</span> */}
                  </div>
                </div>
              </div>
            </article>

            <News_item data={data}
              preslug='blog'

            />

            {/* <!-- Load More --> */}
            {loadMoreBtn && (
              <div className="mt-10 text-center">
                {posts.length > 6 && <button
                  onClick={handleLoadMore}
                  className="items-center  justify-center rounded-md text-[18px] font-medium  bg-gradient-to-tr from-hotPink via-purplish to-accent py-[22px] px-[32px] md:py-[24px] md:px-[38px] cursor-pointer button z-[2] transition-all duration-500 text-white hover:-translate-y-1 text-center"
                >
                  Load More
                </button>
                }
              </div>
            )}
          </div>
        </div>
      </section>
      }
      {/* <!-- end blog --> */}
    </>
  );
};

export default Blog;


export async function getServerSideProps() {



  const { posts, pagination } = await getPaginatedPosts();
  return {
    props: {
      posts: posts || [],
      pagination: {
        ...pagination,
        basePath: '/blogs',
      },
    }
  };


}

// import React from 'react'

// function index() {
//   return (
//     <div>index</div>
//   )
// }

// export default index